// Our own venue table, declared as a source.
//
// `kind: 'human'` is the honest label: nobody fetched this, somebody typed it
// and somebody else checked it. The manifest exists so the rows it produces
// carry the same provenance as everything else — a `source_id`, a trust rank
// that a better source can beat, and an attribution line that says plainly it
// came from us.

import type { SourceManifest } from '../../acquisition/adapter';

const DOCS = 'https://github.com/kwaring555/fsp/blob/main/packages/info/src/sources/venues/data.ts';

export const venues: SourceManifest = {
  id: 'venues',
  name: 'Curated venue locations',
  homepage: DOCS,
  // Deliberately weak. A stadium coordinate typed by hand should lose to any
  // real venue database the moment one with usable terms turns up, and trust
  // rank is the mechanism that makes that a data change rather than a rewrite.
  trustRank: 60,
  kind: 'human',
  // No network, so no budget to spend.
  budget: { unit: 'courtesy' },
  // Runs with everything else; the content hash means an unchanged table costs
  // one comparison and writes nothing.
  cadence: '0 9 * * *',
  emits: ['venue.location'],
  // It says where a venue IS. It does not claim the venue exists — the
  // schedule does that, and minting a second identity for the same stadium is
  // the exact failure the identity layer is here to prevent.
  asserts: [],
  sport: null,
  league: null,
  resources: [
    {
      resource: 'locations',
      acquisition: 'synthetic',
      freshness: 'static',
      license: 'CC0-1.0',
      licenseUrl: 'https://creativecommons.org/publicdomain/zero/1.0/',
      commercialUse: true,
      shareAlike: false,
      redistribution: true,
      // Coordinates are facts about the world and not anyone's property. The
      // compilation is ours and we give it away.
      upstreamName: null,
      upstreamUrl: null,
      attributionText: null,
      termsUrl: DOCS,
      termsReadAt: '2026-09-13',
    },
  ],
};
